import { Preference } from '@app/core/model/user-preferences.interface'
import { ScopeComponent } from '@app/features/scoping/models/component.model'
import { ScopeVersion } from '@app/core/model/scope-version'
import { TableColumnKey } from '../../ui-components/scope-ui-table/table-column-key.enum'
import { isNil } from 'lodash'
import { DEFAULT_PLACEHOLDER } from '@app/shared/constants/default-placeholder.const'

export const getMainComponentColumns = (currentScope: ScopeVersion): Preference[] => [
  {
    key: TableColumnKey.COMPONENT_NAME,
    name: 'COMPONENT',
    selected: true,
    isVisibleInList: () => false,
    value: (component: ScopeComponent) =>
      component.name && component.name.length > 0 ? component.name : component.source.name,
  },
  { key: TableColumnKey.SIZE, name: 'Size', selected: true, field: 'complexity' },
  {
    key: TableColumnKey.QUANTITY_MODIFIER,
    name: `Quantity Modifier`,
    selected: currentScope.isScopeByScenario(),
    value: (entity: ScopeComponent) =>
      !isNil(entity.quantityModifier) && entity.quantityModifier !== 1 ? entity.quantityModifier : DEFAULT_PLACEHOLDER,
    isVisibleInList: () => currentScope.isScopeByScenario(),
  },
  {
    key: TableColumnKey.PRICE_MODIFIER,
    name: `Price Modifier`,
    selected: currentScope.isScopeByScenario(),
    value: (entity: ScopeComponent) =>
      !isNil(entity.priceModifier) && entity.priceModifier !== 1 ? entity.priceModifier : DEFAULT_PLACEHOLDER,
    isVisibleInList: () => currentScope.isScopeByScenario(),
  },
]
